// @flow

import {
  LOAD_SUCCESS,
  RELOAD_SUCCESS,
} from "mmb/scenes/AccountBooking/components/Booking/services/consts"

export const ACTIONS = {
  VIEW_CHANGE: "scheduleChanges/VIEW_CHANGE",
  CHOOSE_PATH: "scheduleChanges/CHOOSE_PATH",
  CHOOSE_FLIGHT_TO_EXCHANGE: "scheduleChanges/CHOOSE_FLIGHT_TO_EXCHANGE",
  SELECT_ALTERNATIVE: "scheduleChanges/SELECT_ALTERNATIVE",
  PREVIEW_ALTERNATIVE: "scheduleChanges/PREVIEW_ALTERNATIVE",
  PLAN_ACCORDINGLY: "scheduleChanges/PLAN_ACCORDINGLY",
  PAY_ALTERNATIVE: "scheduleChanges/PAY_ALTERNATIVE",
  GO_BACK: "scheduleChanges/GO_BACK",
  CLOSING: "scheduleChanges/CLOSING",
  CLOSED: "scheduleChanges/CLOSED",
  API_ERROR: "scheduleChanges/API_ERROR",
  SET_OPEN_STATUS: "scheduleChanges/SET_OPEN_STATUS",
  CHANGE_JOURNEY: "scheduleChanges/CHANGE_JOURNEY",
  SET_LOADING_STATUS: "scheduleChanges/SET_LOADING_STATUS",
  REQUEST_RESOLUTION: "scheduleChanges/REQUEST_RESOLUTION",
  REQUEST_RESOLUTION_REQUEST: "scheduleChanges/REQUEST_RESOLUTION_REQUEST",
  REQUEST_RESOLUTION_FAILURE: "scheduleChanges/REQUEST_RESOLUTION_FAILURE",
  REQUEST_RESOLUTION_SUCCESS: "scheduleChanges/REQUEST_RESOLUTION_SUCCESS",
  [LOAD_SUCCESS]: LOAD_SUCCESS,
  [RELOAD_SUCCESS]: RELOAD_SUCCESS,
  TOGGLE_CONFIRM_REFUND: "TOGGLE_CONFIRM_REFUND",
  SET_FINAL_MODAL: "scheduleChanges/SET_FINAL_MODAL",
  LOAD_SCHEDULE_CHANGE: "scheduleChanges/LOAD",
  LOAD_SCHEDULE_CHANGE_SUCCESS: "scheduleChanges/LOAD_SUCCESS",
  SET_VIEW_ALTERNATIVES: "scheduleChanges/SET_VIEW_ALTERNATIVES",
  LOAD_NO_RESET: "scheduleChanges/LOAD_NO_RESET",
  LOAD_NO_RESET_SUCCESS: "scheduleChanges/LOAD_NO_RESET_SUCCESS",
  LOAD_FAILURE: "scheduleChanges/LOAD_FAILURE",
}
